import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { fmtDate } from "@/lib/helpers";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PlusCircle, FileText } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { SAISIE } from "@/lib/roles";

const TYPES = [
  { key: "", label: "Tous" },
  { key: "P", label: "Conformes" },
  { key: "DECLASSEE", label: "Déclassés" },
];

export default function HistoriqueBL() {
  const [bls, setBls] = useState([]);
  const [type, setType] = useState("");
  const [mois, setMois] = useState("");
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const params = {};
    if (type) params.type = type;
    if (mois) params.mois = mois;
    api.get("/bl", { params }).then((r) => setBls(r.data));
  }, [type, mois]);

  return (
    <div className="space-y-5" data-testid="historique-bl">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-heading font-black text-3xl uppercase tracking-tight text-slate-900">
          Bons de livraison
        </h1>
        {SAISIE.includes(user?.role) && (
          <Button data-testid="new-bl-btn" onClick={() => navigate("/bl/nouveau")}
            className="h-12 bg-emerald-600 hover:bg-emerald-700 font-bold">
            <PlusCircle className="w-5 h-5 mr-1" /> Nouveau BL
          </Button>
        )}
      </div>

      <div className="flex flex-wrap gap-2 items-center">
        {TYPES.map((t) => (
          <button
            key={t.key}
            data-testid={`bl-filter-${t.key || "all"}`}
            onClick={() => setType(t.key)}
            className={`px-4 py-2 rounded-lg font-bold text-sm uppercase tracking-wide ${
              type === t.key ? "bg-slate-900 text-white" : "bg-white border-2 border-slate-200 text-slate-600"
            }`}
          >
            {t.label}
          </button>
        ))}
        <Input data-testid="bl-filter-mois" type="month" value={mois}
          onChange={(e) => setMois(e.target.value)} className="h-11 w-44 ml-auto" />
      </div>

      <div className="rounded-2xl bg-white border-2 border-slate-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b-2 border-slate-200">
              <tr className="text-left text-xs uppercase tracking-wide text-slate-500 font-bold">
                <th className="px-4 py-3">Numéro</th>
                <th className="px-4 py-3">Type</th>
                <th className="px-4 py-3">Destinataire</th>
                <th className="px-4 py-3">Départ</th>
                <th className="px-4 py-3 text-right">Palettes</th>
                <th className="px-4 py-3 text-right">Net total</th>
              </tr>
            </thead>
            <tbody>
              {bls.map((b) => (
                <tr key={b.id} data-testid={`bl-row-${b.numero}`}
                  onClick={() => navigate(`/bl/${b.id}`)}
                  className={`border-b border-slate-100 cursor-pointer hover:bg-slate-50 ${b.statut === "annule" ? "opacity-60" : b.type === "DECLASSEE" ? "bg-rose-50/50" : ""}`}>
                  <td className="px-4 py-3 font-mono font-bold text-slate-900">
                    <span className={b.statut === "annule" ? "line-through" : ""}>{b.numero}</span>
                    {b.statut === "annule" && (
                      <span data-testid={`bl-annule-badge-${b.numero}`} className="ml-2 px-2 py-0.5 rounded text-[10px] font-bold uppercase bg-rose-600 text-white">Annulé</span>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded text-xs font-bold uppercase ${
                      b.type === "P" ? "bg-emerald-100 text-emerald-800" : "bg-rose-100 text-rose-800"
                    }`}>{b.type === "P" ? "Conforme" : "Déclassé"}</span>
                  </td>
                  <td className="px-4 py-3 font-semibold text-slate-700">{b.destinataire.nom}</td>
                  <td className="px-4 py-3 text-slate-600">{fmtDate(b.date_depart)}</td>
                  <td className="px-4 py-3 text-right font-mono">{b.nb_palettes}</td>
                  <td className="px-4 py-3 text-right font-mono font-bold">{b.poids_net_total.toFixed(1)} kg</td>
                </tr>
              ))}
              {bls.length === 0 && (
                <tr>
                  <td colSpan={6} className="px-4 py-12 text-center text-slate-400 font-medium">
                    <FileText className="w-8 h-8 mx-auto mb-2 opacity-40" /> Aucun bon de livraison.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
